import { graphql } from '@revelio/data-access';

export const AllClientUsersQuery = graphql(`
  query GetAllClientUsers($clientName: String!) {
    clients(ids: [$clientName]) {
      users {
        id
        name
        username
        email
        live
        active
        legacy_id
      }
    }
  }
`);

export const AllClientsQuery = graphql(`
  query GetAllClients {
    clients {
      client_name
    }
  }
`);

export const ClientDetailsQuery = graphql(`
  query GetClientDetails($ids: [String]!) {
    clients(ids: $ids) {
      client_name
      company_lists
      active
      tabs
      live
      linkup_postings
      num_seats
      metadata {
        key
        value
      }
      custom_taxonomy
      data_builder_configuration {
        additional_permissions {
          allow_cusip
          contact_info
        }
        client_group
        pipeline_type
        posting_source
        s3_location {
          s3_bucket
          s3_file_prefix
          s3_format
        }
        snowflake_location {
          snowflake_db
          snowflake_schema
          snowflake_file_prefix
        }
      }
      reports_configuration {
        defaults
        report_types
        all_report_types
      }
    }
  }
`);

export const UpdateUserMutation = graphql(`
  mutation UpdateUser(
    $id: String!
    $name: String
    $email: String
    $password: String
    $role: Role
    $client_name: String
    $active: Boolean
    $metadata: [KeyValue]
  ) {
    updateUser(
      input: {
        id: $id
        name: $name
        email: $email
        username: $email
        role: $role
        client_name: $client_name
        password: $password
        active: $active
        metadata: $metadata
      }
    ) {
      id
      name
      username
      email
      role
      client_name
      live
      active
      tabs
      company_lists
      linkup_postings
      num_seats
      metadata {
        key
        value
      }
    }
  }
`);

export const AddUserMutation = graphql(`
  mutation AddUser(
    $name: String!
    $email: String!
    $password: String
    $role: Role!
    $client_name: String!
    $active: Boolean!
    $metadata: [KeyValue]
  ) {
    createUser(
      input: {
        name: $name
        username: $email
        email: $email
        password: $password
        role: $role
        client_name: $client_name
        active: $active
        metadata: $metadata
      }
    ) {
      id
      name
      username
      email
      role
      client_name
      live
      active
      tabs
      company_lists
      linkup_postings
      num_seats
      metadata {
        key
        value
      }
    }
  }
`);

export const UpdateClientGroupMutation = graphql(`
  mutation UpdateClientGroupRewrite(
    $client_name: String!
    $tabs: [Tab!]!
    $live: Boolean!
    $active: Boolean!
    $linkup_postings: Boolean!
    $num_seats: String!
    $metadata: [KeyValue]
    $custom_taxonomy: CustomTaxonomyEnum!
    $data_builder_configuration: PipelineClientConfigInput!
    $reports_configuration: ClientReportsConfigInput
  ) {
    updateClientGroup(
      input: {
        client_name: $client_name
        tabs: $tabs
        live: $live
        active: $active
        linkup_postings: $linkup_postings
        num_seats: $num_seats
        metadata: $metadata
        custom_taxonomy: $custom_taxonomy
        data_builder_configuration: $data_builder_configuration
        reports_configuration: $reports_configuration
      }
    ) {
      client_name
      company_lists
      active
      tabs
      live
      linkup_postings
      num_seats
      custom_taxonomy
    }
  }
`);

export const DeleteUserMutation = graphql(`
  mutation DeleteUser($id: String!) {
    deleteUser(input: $id)
  }
`);

export const ApiKeyManagementQuery = graphql(`
  query ApiKeyManagement($input: IdentityInput!) {
    availableApiKeyEndpoints
    listApiKeys(input: $input) {
      api_keys {
        api_key_id
        created_at
        created_by
        created_by_name
        endpoints
      }
    }
  }
`);

export const AvailableApiKeyEndpointsQuery = graphql(`
  query AvailableApiKeyEndpoints {
    availableApiKeyEndpoints
  }
`);

export const RegisterApiKeyMutation = graphql(`
  mutation RegisterApiKey($input: RegisterApiKeyInput!) {
    registerApiKey(input: $input) {
      api_key
      api_key_id
    }
  }
`);

export const RemoveApiKeyMutation = graphql(`
  mutation RemoveApiKey($input: RemoveApiKeyInput!) {
    removeApiKey(input: $input)
  }
`);
